import { Typography } from "@mui/material"

export const StudentOrder = () => {
    return (
        <Typography>Order...</Typography>
    )
}